import { FunctionComponent } from "react";
import { GeneDataGroupArea, GeneDataGroupType } from "../../api/smartmelts-api/graphql/generated";
import { IIcon } from "../../assets/icons/icon";
import { BODYPART } from "../bodypart";

export interface IMenuCategoryDictionary {
  [key: string]: {
    Icon?: IIcon;
    color?: string;
    subcategories: MenuItemSubcategory[];
    geneDataGroupArea?: GeneDataGroupArea;
    hidden: boolean;
  };
}

export enum MenuItemCategory {
  RECOMMENDATIONS = "RECOMMENDATIONS",
  ORGANS = "ORGANS",
  BLOOD = "BLOOD",
  METABOLISM = "METABOLISM",
  MENTAL_HEALTH = "MENTAL_HEALTH",
  DIET = "DIET",
  MICRONUTRIENTS = "MICRONUTRIENTS",
  TOTAL = "TOTAL",
  USER = "USER",
}

export enum MenuItemSubcategory {
  OVERVIEW = "OVERVIEW",
  MICRONUTRIENTS_TO_INCREASE = "MICRONUTRIENTS_TO_INCREASE",
  FINDINGS = "FINDINGS",
  GENEVARIATIONS = "GENEVARIATIONS",
  HEART = "HEART",
  BRAIN = "BRAIN",
  BONE = "BONE",
  JOINT = "JOINT",
  EYE = "EYE",
  OXIDATIVESTRESS = "OXIDATIVESTRESS",
  METABOLISM = "METABOLISM",
  DETOX = "DETOX",
  GLUTEN = "GLUTEN",
  LACTOSE = "LACTOSE",
  HOMOCYSTEINE = "HOMOCYSTEINE",
  HYPERTENSION = "HYPERTENSION",
  TOTAL = "TOTAL",
  MICRONUTRIENTS = "MICRONUTRIENTS",
  RDA = "RDA",
  FRUCTOSE = "FRUCTOSE",
  USER_DATA = "USER_DATA",
  FAVOURITES = "FAVOURITES",
  USER_REPORTS = "USER_REPORTS",
  RESILIENCE = "RESILIENCE",
}

export enum Explanation {
  NUTRIENT = "NUTRIENT",
  GENE_VARIATIONS = "GENE_VARIATIONS",
}

export interface IMenuSubcategoryDictionary {
  [key: string]: {
    pages?: FunctionComponent[];
    explanations?: Array<Explanation | null>;
    bodypart?: BODYPART;
    geneDataGroupTypes: GeneDataGroupType[];
    isQuestionBased: boolean;
    enabledForDemo: boolean;
    hideFooter?: boolean;
  };
}

export interface IColorCategoryDictionary {
  [key: string]: {
    color: string;
    lightColor: string;
  };
}

export interface IExplanationDictionary {
  [key: string]: FunctionComponent[];
}
